import { useMemo, useState } from "react";
import { EarningsBreakdowns } from "./EarningsBreakdowns";
import { EarningsCharts } from "./EarningsCharts";
import { EarningsHeader } from "./EarningsHeader";
import { EarningsSummaryCards } from "./EarningsSummaryCards";

export function EarningsMonitor({ earnings }) {
  const [activePeriod, setActivePeriod] = useState("daily");
  const activeSummary = useMemo(
    () => earnings.summaries.find((summaryItem) => summaryItem.period === activePeriod) || earnings.summaries[0],
    [activePeriod, earnings],
  );

  if (!activeSummary) return null;

  return (
    <section className="panel earnings-panel" data-testid="earnings-monitor-panel">
      <EarningsHeader activePeriod={activePeriod} setActivePeriod={setActivePeriod} activeSummary={activeSummary} />
      <EarningsSummaryCards summary={activeSummary} />
      <EarningsCharts series={activeSummary.series} />
      <EarningsBreakdowns summary={activeSummary} />
    </section>
  );
}